
<div class="container" style="border:1px solid #bebaba">
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight: bold">Frequently Asked Questions</h3>
      <br />
      <div id="accordion">
        <div class="card">
          <div class="card-header">
            <a class="card-link" data-toggle="collapse" href="#collapseOne">
              1.	Why is there a notice?
            </a>
          </div>
          <div id="collapseOne" class="collapse" data-parent="#accordion">
            <div class="card-body">
              A Court authorized this Notice because you have a right to know about a proposed Settlement, and your
              rights and options, before the Court decides whether to approve the Settlement. This Notice explains the
              lawsuit, the Settlement, and your legal rights. Your legal rights are affected whether you act or not.<br /><br />

              Judge Richard J. Leon, of the United States District Court for the District of Columbia, is currently
              overseeing this case. This lawsuit is called <i>Burke v. Visa Inc</i>., No. 1:11-cv-01882. The people who filed
              the class action case are called the Plaintiffs. The Defendants in the lawsuit are Visa and Mastercard.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
              2.	What is this lawsuit about?
            </a>
          </div>
          <div id="collapseTwo" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The lawsuit says that certain network operating rules in the Visa and Mastercard agreements with IATM
              operators violated federal and state antitrust laws. The laws include the Sherman Antitrust Act, 15
              U.S.C. § 1, et seq., and California, Illinois, Massachusetts, and Michigan state antitrust laws.<br /><br />

              When cardholders use an ATM that is not associated with their bank, they must pay a surcharge or
              “access fee” to withdraw money from their bank accounts. Networks, owned by companies such as Visa
              and Mastercard, facilitate these transactions and connect the ATM to the cardholder’s bank.<br /><br />

              The Visa and Mastercard operating rules prohibit IATM operators from charging different ATM access
              fees or “discounting” (charging cardholders a lower access fee) if transactions could be processed
              on competing networks that cost less than the Visa or Mastercard networks. Plaintiffs claim that
              the operating rules are price fixing, and cardholders paid higher access fees to use independent
              ATMs than they should have.<br /><br />

              Visa and Mastercard deny these claims and that they did anything wrong.<br /><br />

              This Notice is only a summary. More detail is provided in the Settlement Agreement, available
              <a href="../../../assets/documents/Exhibit A Stipulation and Agreement of Settlement.pdf" target="_blank">here</a>.
              
            </div>

          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
              3.	What is an Independent ATM or IATM?
            </a>
          </div>
          <div id="collapseThree" class="collapse" data-parent="#accordion">
            <div class="card-body">
              An Independent ATM (or “IATM”) is an automated teller machine that is not owned by Visa, Mastercard, or any bank or other financial institution.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
              4.	Why is this a class action?
            </a>
          </div>
          <div id="collapseFour" class="collapse" data-parent="#accordion">
            <div class="card-body">
              In a class action, one or more people called “class representatives” (in this case, Peter Burke, Kent Harrison, Marin P. Heiskell, and Brian Byrnes) sue on behalf of people who have similar claims. All of these people are a “class” or “class members.” One court and one case resolve the issues for all class members, except for those people who exclude themselves from the class.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
              5.	Why is there a Settlement?
            </a>
          </div>
          <div id="collapseFive" class="collapse" data-parent="#accordion">
            <div class="card-body">
              By agreeing to the Settlement, both sides avoid the costs and uncertainty of a trial, and Class Members receive the benefits described in this Notice. The Court has not decided in favor of the Plaintiffs or Visa and Mastercard. Instead, both sides have voluntarily participated in a formal mediation and have agreed to a Settlement. The proposed Settlement does not mean that any law was broken or that Visa or Mastercard did anything wrong. Class Co-Lead Counsel and the class representatives believe that the Settlement is best for all Class Members.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSix">
              6.	What are the other related lawsuits? Why did I get other notices?
            </a>
          </div>
          <div id="collapseSix" class="collapse" data-parent="#accordion">
            <div class="card-body">
              There are three related (or parallel) lawsuits that were filed in October 2011. They each involve different
              classes with similar claims and are proceeding at the same time. You may receive notices about these other
              cases.<br /><br />

              This Notice is about a proposed Settlement in the case called <i>Burke v. Visa Inc</i>., No. 1:11-cv-01882.
              This case involves individuals who were charged unreimbursed access fees to withdraw cash at independent ATMs.
              There is now a proposed Settlement with Visa and Mastercard. <b>
                This Notice is about the proposed Settlement
                in this case
              </b>.<br /><br />

              Another related case is called <i>Mackmin v. Visa Inc</i>., No. 1:11-cv-01831. This case involves individuals
              and entities who were charged unreimbursed access fees to withdraw cash at bank-operated ATMs. You may have
              received previous notices about settlements in this case that were with certain banks (“first settlements”)
              and/or with Visa and Mastercard (“second settlement”). The first settlements were approved on August 22, 2022,
              and totaled $67 million. The second settlement was approved on June 20, 2025, and totaled $197.5 million.
              You may have filed a claim and/or received a payment from these settlements.<br /><br />

              The last related case is known as <i>National ATM Council v. Visa Inc</i>., No. 1:11-cv-01803. It involves
              entities or businesses that own and/or operate independent ATMs.<br /><br />

              <b>
                You may be included in more than one class, so it is important to read this Notice and any other notices
                you receive carefully, so you can understand your rights and options
              </b>. The choices you make to act on your
              rights in this case (Burke v. Visa Inc.) will not affect your rights in the other related lawsuits.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeven">
              7.	Who is included in the Settlement?
            </a>
          </div>
          <div id="collapseSeven" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You are included in the Settlement as part of the Nationwide Class if you are a person who was charged
              an access fee for a domestic cash withdrawal transaction at an Independent ATM (“IATM”) in the United
              States between October 24, 2007, and August 14, 2026, and were not fully reimbursed by your bank.<br /><br />

              A domestic cash withdrawal transaction is a transaction to withdraw cash from a customer’s deposit account
              using an ATM or pin-debit card at an IATM terminal located within the United States, including its territories.
              It does not include any credit card transaction or any transaction involving a cash advance or prepaid card.<br /><br />

              You may also be included in the Settlement as part of one or more of the Statewide Classes if you were in
              California, Illinois, Massachusetts, and/or Michigan when you were charged an access fee for a domestic cash
              withdrawal transaction at an IATM between October 24, 2007, and August 14, 2026, and were not fully reimbursed
              by your bank.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseEight">
              8.	Who is not included?
            </a>
          </div>
          <div id="collapseEight" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The Class does <b><u>not</u></b> include:<br /><br />

              <ul>
                <li>
                  Visa and Mastercard;
                </li>
                <li>
                  Visa and Mastercard’s officers, directors, and employees;
                </li>
                <li>
                  Any entity in which Visa or Mastercard have a controlling interest;
                </li>
                <li>
                  Visa’s and Mastercard’s affiliates, legal representatives, heirs, or assigns;
                </li>
                <li>
                  Federal, state, or local government entities;
                </li>
                <li>
                  Any judicial officer presiding over this case, their staff, and any member of their immediate family;
                </li>
                <li>
                  Any juror assigned to this case; and
                </li>
                <li>
                  Anyone that excludes themselves from the Settlement (<i>see</i> Question 18).
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseNine">
              9.	What does the Settlement provide?
            </a>
          </div>
          <div id="collapseNine" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If the Settlement is approved, Visa and Mastercard will collectively pay $167,500,000—Visa
              ($88,775,000.00) and Mastercard ($78,725,000.00)—into a Settlement Fund. After deductions
              for attorneys’ fees, litigation costs, and other expenses; taxes and tax expenses; up to
              $3 million in notice and administration costs; and service awards, the Net Settlement Fund
              will be distributed to Class Members who submit valid claims.<br /><br />

              The Settlement Agreement, available <a href="../../../assets/documents/Exhibit A Stipulation and Agreement of Settlement.pdf" target="_blank">here</a>, has more information.
            </div>
          </div>
        </div>
        <br />

        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTen">
              10.	How much money can I get from the Settlement?
            </a>
          </div>
          <div id="collapseTen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Each valid claim will be eligible to receive a <i>pro rata</i> (or proportional) share of the Net Settlement Fund, based on the number of qualifying surcharged transactions that are submitted. Because the amount of each payment depends on the number of approved transactions, nobody can know in advance how much the payment will be.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseEleven">
              11.	What am I giving up to stay in the Settlement?
            </a>
          </div>
          <div id="collapseEleven" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Unless you exclude yourself, you will remain in the Settlement. You will give up your right to separately sue Visa and Mastercard about the claims in this lawsuit. All of the Court’s decisions and judgments will bind you.

              The Settlement Agreement describes the specific claims you will give up (or “release”), so read it carefully. The Settlement Agreement is available <a href="../../../assets/documents/Exhibit A Stipulation and Agreement of Settlement.pdf" target="_blank">here</a>.

              If you have questions, you may contact the Claims Administrator by writing to Non-Bank ATM Surcharge Fee Settlement, c/o A.B. Data, Ltd., P.O. Box 173053, Milwaukee, WI 53217, emailing info@NonbankATMSurchargeSettlement.com, or calling the toll-free number 1-866-893-1052.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwelve">
              12.	How can I get a payment?
            </a>
          </div>
          <div id="collapseTwelve" class="collapse" data-parent="#accordion">
            <div class="card-body">
              To ask for a payment, you must complete and submit a Claim Form. You can get a Claim Form <a href="../../../assets/documents/Burke v. Visa_Claim Form_FINAL.pdf" target="_blank">here</a>
              or by calling 1-866-893-1052.<br /><br />

              You must submit your Claim Form online or by mail, so it is <b>received no later than February 10, 2027</b>.
              Claims submitted by mail should be sent to:<br /><br />

              <p style="text-align:center">
                Non-Bank ATM Surcharge Fee Settlement<br />
                c/o A.B. Data, Ltd.<br />
                P.O. Box 173053<br />
                Milwaukee, WI 53217
              </p>


            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirteen">
              13.	When will I get my payment?
            </a>
          </div>
          <div id="collapseThirteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The Court is scheduled to hold a hearing on <b>February 17, 2027</b>, to decide whether to approve the Settlement. The hearing may be held electronically or moved to a different date or time without additional notice, so it is a good idea to check this website for additional information. If the Court approves the Settlement, that decision may be appealed. It is hard to estimate how long it might take for any appeals to be resolved. If the Settlement is approved and no appeals are filed, the Claims Administrator anticipates that payments will be sent out within six months. Settlement payments will be digitally sent to you via email. Please make sure you provide a current, valid email address on the Claim Form. When you receive the email notifying you about your payment, you will be provided with a number of digital payment options to select from, such as PayPal or a virtual debit card. For many people, this is the easiest and quickest option to receive money. You will also have the opportunity to request that a check be mailed to you by the Claims Administrator. Please be patient. Updates will be posted on the website.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFourteen">
              14.	What happens if my contact information changes?
            </a>
          </div>
          <div id="collapseFourteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you change your mailing address or email address after you submit a Claim Form, it is your responsibility
              to inform the Claims Administrator of your updated information. Notify the Claims Administrator of any changes
              to your mailing address or email address by writing:<br /><br />

              <p style="text-align:center">
                Non-Bank ATM Surcharge Fee Settlement<br />
                c/o A.B. Data, Ltd.<br />
                P.O. Box 173053<br />
                Milwaukee, WI 53217<br />
                info@NonbankATMSurchargeSettlement.com
              </p>


            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFifteen">
              15.	What happens if some of the money remains after distribution?
            </a>
          </div>
          <div id="collapseFifteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If there is any money remaining after all claims are processed, those funds will be paid to a non-profit organization or “next best” recipient as approved by the Court. No remaining funds will be returned to Visa or Mastercard.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen">
              16.	Do I have a lawyer in the case?
            </a>
          </div>
          <div id="collapseSixteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. The Court has appointed lawyers at the following law firms to represent you and the other Class Members as “Class Co-Lead Counsel:”
              <br /><br />
              <div class="row">
                <div class="col-md-6">
                  Douglas G. Thompson<br />
                  <b>Finkelstein Thompson LLP</b><br />
                  2201 Wisconsin Ave. NW<br />
                  Suite 200<br />
                  Washington, DC 20007<br /><br />
                </div>
                <div class="col-md-6">

                  Christopher Lovell<br />
                  <b>Lovell Stewart Halebian Jacobson LLP</b><br />
                  225 Broadway<br />
                  Suite 3600<br />
                  New York, NY 10007<br /><br />

                </div>
                You will not be charged for these lawyers. If you want to be represented by another lawyer, you may hire one to appear in Court for you at your own expense.
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeventeen">
              17.	How will the lawyers be paid?
            </a>
          </div>
          <div id="collapseSeventeen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You do not have to pay Class Co-Lead Counsel. Class Co-Lead Counsel have not been paid anything to date
              for their work on this case. Class Co-Lead Counsel will ask the Court for attorneys’ fees of up to 30%
              of the Settlement Fund, plus reimbursement of costs and expenses. Class Co-Lead Counsel will also ask
              the Court for service awards up to $17,500 for each class representative for their work on behalf of
              the Nationwide and Statewide Classes.<br /><br />

              Any attorneys’ fees and expenses and service awards approved by the Court will be paid out of the
              Settlement Fund.<br /><br />

              When Class Co-Lead Counsel’s motion for fees, expenses, and class representative service awards is
              filed, it will be available at <a [routerLink]="['/court-documents']">here</a>.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseEighteen">
              18.	How do I exclude myself from the Settlement?
            </a>
          </div>
          <div id="collapseEighteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You may exclude yourself by mailing a letter to the Claims Administrator (at the address below)
              with the following information:<br /><br />

              <ul>
                <li>
                  A statement that you are a Class Member and want to be excluded from the Settlement in
                  <i>Burke v. Visa Inc</i>., No. 1:11-cv-01882;
                </li>
                <li>
                  Your full name, address, and telephone number;
                </li>
                <li>
                  Your email address (if any); and
                </li>
                <li>
                  Your signature.
                </li>
              </ul>

              You must mail your letter, so it is <b>received no later than December 11, 2026</b>, to:<br /><br />

              <p style="text-align:center">
                Non-Bank ATM Surcharge Fee Settlement<br />
                ATTN: EXCLUSIONS<br />
                P.O. Box 173001<br />
                Milwaukee, WI 53217
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseNineteen">
              19.	If I exclude myself, can I still get a payment?
            </a>
          </div>
          <div id="collapseNineteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. If you exclude yourself, you will not be eligible to receive a payment from the Settlement with Visa and Mastercard.

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwenty">
              20.	If I don’t exclude myself, can I sue Visa and Mastercard for the same thing later?
            </a>
          </div>
          <div id="collapseTwenty" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. Unless you opt out, you give up the right to sue Visa and Mastercard for the claims this Settlement resolves.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyOne">
              21.	What happens if I exclude myself?
            </a>
          </div>
          <div id="collapseTwentyOne" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you exclude yourself, you will not have any rights as a Class Member under the Settlement with Visa and Mastercard; you will not receive any payment as part of the Settlement; you will not be bound by any further orders or judgments in this case; and you will keep the right, if any, to sue Visa and Mastercard about the claims alleged in the case, at your own expense.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyTwo">
              22.	If I exclude myself, am I still represented by Class Co-Lead Counsel?
            </a>
          </div>
          <div id="collapseTwentyTwo" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. Class Co-Lead Counsel represents the members of the Class. If you exclude yourself from the Class, you are not represented by Class Co-Lead Counsel.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyThree">
              23.	How do I tell the Court that I do not like the Settlement?
            </a>
          </div>
          <div id="collapseTwentyThree" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You have a right to object to or comment on any part of the proposed Settlement and/or the request for
              attorneys’ fees, costs, and expenses and service awards. The Court will consider your views. You can’t
              ask the Court to order a different Settlement; the Court can only approve or reject the Settlement. If
              the Court does not approve the Settlement, no Settlement payments will be made, and the lawsuit against
              Visa and Mastercard will continue. If that is what you want to happen, you must object.<br /><br />

              To comment on or object, you must mail a letter with the following information:<br/><br/>

              <ul>
                <li>
                  The name and case number of this lawsuit, <i>Burke v. Visa Inc</i>., No. 1:11-cv-01882;
                </li>
                <li>
                  Your full name, address, and telephone number;
                </li>
                <li>
                  Your email address (if any);
                </li>
                <li>
                  An explanation of why you believe you are a Class Member;
                </li>
                <li>
                  A statement saying you object to the Settlement in this case;
                </li>
                <li>
                  A statement whether the objection applies only to you, to a specific subset of the Nationwide and/or Statewide Class(es), or to the all the Class(es);
                </li>
                <li>
                  The reasons you object;
                </li>
                <li>
                  Any documents and/or supporting evidence;
                </li>
                <li>
                  A statement of whether you (or your lawyer) intend to appear and speak at the Final Fairness Hearing;
                </li>
                <li>
                  Your lawyer’s signature (if you have one); and
                </li>
                <li>
                  Your signature.
                </li>
              </ul>

              You must mail your objection to (or file it with) the Court at the following address,
              <b>postmarked by December 11, 2026</b>:<br/><br/>

                                                          <p style="text-align:center">
                                                            <b>Court</b><br/>
                                                            Court Clerk<br/>
                                                            United States District Court for the District of Columbia<br/>
                                                            333 Constitution Avenue NW<br/>
                                                            Washington, DC 20001<p>



</div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyFour">
              24.	If I object to the Settlement, can I still file a claim?
            </a>
          </div>
          <div id="collapseTwentyFour" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. You may file a claim even if you object to, or comment on, the Settlement.

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyFive">
              25.	What’s the difference between excluding yourself and objecting?
            </a>
          </div>
          <div id="collapseTwentyFive" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Objecting is simply telling the Court that you do not like something about the Settlement.
              You can object to the Settlement when you disagree with some aspect of the Settlement and
              think the Court should not approve it. An objection, like a comment, allows your views to
              be heard in Court.<br/><br/>

              Excluding yourself is telling the Court that you do not want to be a part of the Settlement
              and do not want the Settlement to apply to you. If you exclude yourself, you cannot receive
              a payment from the Settlement. If you exclude yourself, you will also have no right to object
              to the Settlement and appear at the Final Fairness Hearing, because the case no longer affects you.

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentySix">
              26.	What happens if I do nothing at all?
            </a>
          </div>
          <div id="collapseTwentySix" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you do nothing, you will stay a Class Member and will not be able to sue Visa or Mastercard for
              the claims in this lawsuit. You will be bound by the Court’s decisions. If the Court approves the
              Settlement, you will not get any money.<br/><br/>

              To ask for a payment, you must complete and submit a Claim Form by February 10, 2027 (<i>see</i> Question 12).

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentySeven">
              27.	When and where will the Court decide whether to approve the Settlement?
            </a>
          </div>
          <div id="collapseTwentySeven" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The Court will hold a Fairness Hearing at <b>4:00 p.m. on February 17, 2027</b>, at the U.S. District Court
              for the District of Columbia, 333 Constitution Avenue N.W., Courtroom 18, Washington, D.C. 20001. The
              hearing may be moved to a different date or time without additional notice, so be sure to check this
              website for updates.<br/><br/>

              At this hearing, the Court will consider whether the Settlement is fair, reasonable, and adequate. If
              there are objections, the Court will consider them and may listen to people who have asked to speak at
              the hearing. The Court may also decide whether to award attorneys’ fees, costs, and expenses and service
              awards for the class representatives. After the hearing, the Court will decide whether to approve the
              Settlement. We do not know how long these decisions will take.

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyEight">
              28.	Do I have to come to the Fairness Hearing?
            </a>
          </div>
          <div id="collapseTwentyEight" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. Class Co-Lead Counsel will answer any questions the Court may have. You may attend at your own expense. If you send an objection, you do not have to come to Court to talk about it. As long as you mailed your written objection on time, the Court will consider it. You may also pay your own lawyer to attend, but it is not necessary.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyNine">
              29.	May I speak at the hearing?
            </a>
          </div>
          <div id="collapseTwentyNine" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. You may ask the Court for permission to speak at the Fairness Hearing. To do so, you must send a letter stating that it is your “Notice of Intention to Appear in Burke v. Visa Inc., No. 1:11-cv-01882.” Be sure to include your full legal name, address, telephone number, and signature. Your Notice of Intention to Appear must be <b>postmarked no later than December 11, 2026</b>, and must be sent to the Court’s address listed in Question 23.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirty">
              30.	How do I get more information?
            </a>
          </div>
          <div id="collapseThirty" class="collapse" data-parent="#accordion">
            <div class="card-body">
              This Notice is only a summary. More details are in the Settlement Agreement. You can get a copy of the
              Settlement Agreement, view other case documents, and get additional information and updates <a [routerLink]="['/court-documents']">here</a>.
              If you have questions, you also may contact the Claims Administrator by writing to Non-Bank ATM
              Surcharge Settlement, c/o A.B. Data, Ltd., P.O. Box 173053, Milwaukee, WI 53217, emailing
              info@NonbankATMSurchargeSettlement.com, or calling the toll-free number 1-866-893-1052.<br/><br/>

              All of the case documents that have been filed publicly in this case are also available online
              through the Court’s Public Access to Court Electronic Records (PACER) system at
              https://ecf.dcd.uscourts.gov. You may also obtain case documents by visiting the office of the
              Clerk of the Court for the United States District Court for the District of Columbia, 333
              Constitution Avenue N.W., Washington, D.C. 20001, between 9:00 a.m. and 4:00 p.m., Monday
              through Friday, excluding court-observed holidays.
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>
<br />
   







